/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Get_Task_Management, Get_Task_Status, Get_Task_Type } from '../../../../redux/action';
import style from '../../../../assets/styles/userManagement.module.css';
import NativeButton from '../../../atoms/Button';
import { Pagination } from '../../common/Pagination';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../common/Toast';
import RightPanelTopMenu from '../../common/RightPanelTopMenu';
import AuthLayout from '../../../../layout/AuthLayout';
import RecentActivity from './RecentActivity';

const Tasklist = () => {
  //  show data of all
  const limit = 15;
  const toast = useToast();
  const [last, setLast] = useState(5);
  const [offset, setOffset] = useState(0);
  const [sortOrganisation, setSortOrganisation] = useState(true);
  const [sortTaskType, setSortTaskType] = useState(true);
  const [sortItem, setSortItem] = useState(true);
  const dispatch = useDispatch();
  const [organizationId, setOrganizationId] = useState(() => {
    const storedId = localStorage.getItem('selectedOrgId');
    return storedId ? Number(storedId) : null;
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [inputPage, setInputPage] = useState(currentPage);
  const [sortCreatedAtIcon, setSortCreatedAtIcon] = useState(true);
  const [sortEndDateIcon, setSortEndDateIcon] = useState(false);
  const [sortQuestionBankIcon, setSortQuestionBankIcon] = useState(false);
  const [sortTaskTypeIcon, setSortTaskTypeIcon] = useState(false);
  const [sortAssignToIcon, setSortAssignToIcon] = useState(false);
  const [sortItemIcon, setSortItemIcon] = useState(false);
  const navigate = useNavigate();
  const [sortAssignTo, setSortAssignTo] = useState(true);
  const [sortStatus, setSortStatus] = useState(true);
  const [sortCreatedAt, setSortCreatedAt] = useState(true);
  const [sortEndDate, setSortEndDate] = useState(true);
  const [sortStatusIcon, setSortStatusIcon] = useState(false);
  const [sort, setSort] = useState('-updated_at');
  const [taskFilterValue, setTaskFilterValue] = useState('');
  const [isFilerData, setIsFilerData] = useState(false);
  const [taskTypeFilterValue, setTaskTypeFilterValue] = useState('');
  const taskFilter = [
    { name: 'All tasks', value: '' },
    { name: 'Assign to me', value: 0 },
    { name: 'To be approved', value: 1 },
  ];

  const [taskStatus, setTaskStatus] = useState('');
  const { taskList, taskStatusList, taskTypeList } = useSelector((state) => state.GetAllData);
  useEffect(() => {
    if (currentPage && currentPage > 0) {
      setIsLoading(true);
      dispatch(
        Get_Task_Management(
          organizationId,
          limit,
          sort,
          currentPage,
          taskStatus,
          taskTypeFilterValue,
          taskFilterValue,
          toast
        )
      );
    }

    if (!taskStatusList) {
      dispatch(Get_Task_Status());
    }
    if (!taskTypeList) {
      dispatch(Get_Task_Type());
    }
  }, [organizationId, sort, limit, currentPage, taskStatus, taskTypeFilterValue, taskFilterValue]);

  useEffect(() => {
    setIsLoading(true);
    setCurrentPage(1);
    setInputPage(1);
    setOffset(0);
  }, []);

  useEffect(() => {
    if (taskList?.count) {
      setIsLoading(false);
      const totalResults = taskList?.count;
      // If the current offset is greater than the total results,
      // reset to first page
      if (offset >= totalResults && totalResults > 0) {
        setOffset(0);
        setCurrentPage(1);
        setInputPage(1);
        setLast(Math.min(15, totalResults));
        setTotalCount(offset);
      } else {
        if (totalResults) {
          setTotalCount(totalResults);
          setLast(Math.min(offset + 15, totalResults));
        }
        if (!totalResults) {
          setTotalCount(0);
          setLast(1);
          setOffset(0);
        }
      }
    }
    if (taskList?.error) {
      setTotalCount(0);
    }
  }, [taskList, organizationId]);
  useEffect(() => {
    if (taskList) {
      setIsLoading(false);
    }
  }, [taskList]);

  const sortStatusFunction = () => {
    if (sortStatus) {
      setSort('task_status');
      setSortStatus(!sortStatus);
      setSortStatusIcon(true);
    } else {
      setSort('-task_status');
      setSortStatus(!sortStatus);
      setSortStatusIcon(true);
    }
    setSortAssignToIcon(false);
    setSortQuestionBankIcon(false);
    setSortTaskTypeIcon(false);
    setSortCreatedAtIcon(false);
    setSortEndDateIcon(false);
    setSortItemIcon(false);
    setSortQuestionBankIcon(false);
    setSortCreatedAtIcon(false);
  };

  const sortAssignFunction = () => {
    setSortAssignToIcon(true);
    setSortQuestionBankIcon(false);
    setSortTaskTypeIcon(false);
    setSortCreatedAtIcon(false);
    setSortEndDateIcon(false);
    setSortItemIcon(false);
    setSortStatusIcon(false);
    if (sortAssignTo) {
      setSort('assign_to');
      setSortAssignTo(!sortAssignTo);
    } else {
      setSort('-assign_to');
      setSortAssignTo(!sortAssignTo);
    }
  };

  const sortQuestionBankFunction = () => {
    setSortAssignToIcon(false);
    setSortQuestionBankIcon(true);
    setSortTaskTypeIcon(false);
    setSortCreatedAtIcon(false);
    setSortEndDateIcon(false);
    setSortItemIcon(false);
    setSortStatusIcon(false);
    if (sortOrganisation) {
      setSort('question_bank');
      setSortOrganisation(!sortOrganisation);
    } else {
      setSort('-question_bank');
      setSortOrganisation(!sortOrganisation);
    }
  };
  const sortItemsFunction = () => {
    setSortAssignToIcon(false);
    setSortQuestionBankIcon(false);
    setSortTaskTypeIcon(false);
    setSortCreatedAtIcon(false);
    setSortEndDateIcon(false);
    setSortItemIcon(true);
    setSortStatusIcon(false);
    if (sortItem) {
      setSort('item_count');
      setSortItem(!sortItem);
    } else {
      setSort('-item_count');
      setSortItem(!sortItem);
    }
  };
  const sortTaskTypeFunction = () => {
    setSortAssignToIcon(false);
    setSortQuestionBankIcon(false);
    setSortTaskTypeIcon(true);
    setSortCreatedAtIcon(false);
    setSortEndDateIcon(false);
    setSortItemIcon(false);
    setSortStatusIcon(false);
    if (sortTaskType) {
      setSort('task_type');
      setSortTaskType(!sortTaskType);
    } else {
      setSort('-task_type');
      setSortTaskType(!sortTaskType);
    }
  };
  const getRotation = (column) => {
    if (sort === column) {
      return 'rotate(180deg)';
    }
    return 'rotate(0deg)';
  };

  const sortCreatedFunction = () => {
    setSortAssignToIcon(false);
    setSortQuestionBankIcon(false);
    setSortTaskTypeIcon(false);
    setSortCreatedAtIcon(true);
    setSortEndDateIcon(false);
    setSortItemIcon(false);
    setSortStatusIcon(false);
    if (sortCreatedAt) {
      setSort('-created_at');
      setSortCreatedAt(!sortCreatedAt);
    } else {
      setSort('created_at');
      setSortCreatedAt(!sortCreatedAt);
    }
  };
  const sortEndDateFunction = () => {
    setSortAssignToIcon(false);
    setSortQuestionBankIcon(false);
    setSortTaskTypeIcon(false);
    setSortCreatedAtIcon(false);
    setSortEndDateIcon(true);
    setSortItemIcon(false);
    setSortStatusIcon(false);
    if (sortEndDate) {
      setSort('end_date');
      setSortEndDate(!sortEndDate);
    } else {
      setSort('-end_date');
      setSortEndDate(!sortEndDate);
    }
  };

  return (
    <AuthLayout>
      <RightPanelTopMenu
        setQuestionBankId={null}
        title="Task Management"
        showOrgDropdown={true}
        setOrganisationId={(id) => setOrganizationId(id)}
      />
      <div className={`${style.question_bank_table_top} ${style.TaskList_topTable}`}>
        <div className={style.TaskList_section}>
          {/* TABLE SECTION OF THIS PAGE  */}
          <div style={{ flex: 2 }} className={style.Testtext}>
            <span>Task List</span>
          </div>
          <div className={`${style.table_content_report} ${style.user_table_content} ${style.TaskList_table_content}`}>
            {/* _______________________Top content of table_______________________  */}
            <div className={style.filterleftHeading}>Filter By</div>
            <div className={style.TaskList_topcontent_table}>
              <div className={` ${style.TaskList_leftContainer_wrap}`}>
                <div style={{ width: '35%' }}>
                  <select
                    style={{ color: 'black' }}
                    className={` ${style.Taskdropdown_css} ${style.dropTasks}`}
                    id="searchInput"
                    value={taskFilterValue}
                    onChange={(e) => {
                      setTaskFilterValue(e.target.value);
                      setIsFilerData(true);
                      setCurrentPage(1);
                    }}
                    placeholder="All Task"
                    name="cars"
                  >
                    {taskFilter.map((item) => (
                      <option value={item.value}>{item.name}</option>
                    ))}
                  </select>
                </div>
                <div style={{ width: '40%' }}>
                  <select
                    style={{ color: 'black' }}
                    className={` ${style.Taskdropdown_css} ${style.dropTasks}`}
                    id="searchInput"
                    value={taskTypeFilterValue}
                    onChange={(e) => {
                      setTaskTypeFilterValue(e.target.value);
                      setIsFilerData(true);
                      setCurrentPage(1);
                    }}
                    placeholder="Choose task type"
                    name="Task Type"
                  >
                    <option value={''}>Choose task type</option>
                    {taskTypeList?.map((item) => (
                      <option value={item?.id}>{item?.type}</option>
                    ))}
                  </select>
                </div>
                <div style={{ width: '33%' }}>
                  <select
                    style={{ color: 'black' }}
                    className={` ${style.Taskdropdown_css} ${style.dropTasks}`}
                    id="searchInput"
                    onChange={(e) => {
                      setTaskStatus(e.target.value);
                      setIsFilerData(true);
                      setCurrentPage(1);
                    }}
                    value={taskStatus}
                    placeholder="Task status"
                    name="cars"
                  >
                    <option value="">Choose status</option>
                    {taskStatusList?.map((item) => (
                      <option value={item?.id}>{item?.status}</option>
                    ))}
                  </select>
                </div>
                <div style={{ width: '32%', fontSize: '14px', fontWeight: '500' }}>
                  <button
                    className={` ${style.ResetFilterWrap}`}
                    onClick={() => {
                      if (isFilerData) {
                        setTaskStatus('');
                        setTaskTypeFilterValue('');
                        setTaskFilterValue('');
                        setCurrentPage(1);
                      }
                    }}
                    disabled={!isFilerData}
                    style={{ border: 'none', background: 'none', padding: '0px' }}
                  >
                    <div className={style.reverse_drop} style={{ paddingLeft: '0px' }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12.0001 5.40039C11.022 5.40039 10.1345 5.557 9.32483 5.79899C8.92796 5.91759 8.51009 5.69201 8.39148 5.29514C8.27288 4.89827 8.49846 4.4804 8.89532 4.36179C9.82561 4.08378 10.8582 3.90039 12.0001 3.90039C17.2043 3.90039 21.4201 8.11618 21.4201 13.3204C21.4201 18.5246 17.2043 22.7404 12.0001 22.7404C6.79586 22.7404 2.58008 18.5246 2.58008 13.3204C2.58008 11.3868 3.16704 9.58286 4.16604 8.08437C4.3958 7.73972 4.86146 7.64659 5.2061 7.87635C5.55075 8.10612 5.64388 8.57177 5.41412 8.91642C4.57311 10.1779 4.08008 11.694 4.08008 13.3204C4.08008 17.6962 7.62429 21.2404 12.0001 21.2404C16.3759 21.2404 19.9201 17.6962 19.9201 13.3204C19.9201 8.9446 16.3759 5.40039 12.0001 5.40039Z"
                          fill="#272727"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M11.2516 1.43431C11.564 1.70627 11.5968 2.18001 11.3248 2.49244L8.43485 5.81244C8.16289 6.12487 7.68915 6.15767 7.37672 5.88571C7.0643 5.61375 7.03149 5.14001 7.30345 4.82758L10.1935 1.50758C10.4654 1.19516 10.9392 1.16235 11.2516 1.43431Z"
                          fill="#272727"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.26342 4.87817C7.50764 4.54361 7.97683 4.47037 8.31139 4.71459L11.6814 7.17459C12.0159 7.41881 12.0892 7.888 11.845 8.22256C11.6007 8.55712 11.1316 8.63036 10.797 8.38614L7.427 5.92614C7.09244 5.68192 7.0192 5.21273 7.26342 4.87817Z"
                          fill="#272727"
                        />
                      </svg>
                      <p>Reset Filter</p>
                    </div>
                  </button>
                </div>
              </div>

              {/*_______________________ Create New Task Button  _______________________ */}
              <div className={style.TaskAdd_new_TaskWrap}>
                <button
                  className={` ${style.TaskAdd_new_task} ${style.pointer}`}
                  onClick={() => navigate('/task-management/add')}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                      fill="white"
                    />
                    <path
                      d="M7.5 12H16.5"
                      stroke="#00ABFB"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12 16.5V7.5"
                      stroke="#00ABFB"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span>Create New Task</span>
                </button>
              </div>
            </div>

            {/* TABLE LISTING OF REPORT  */}
            {totalCount && totalCount !== 0 ? (
              <div
                className={`${style.sub_head_content_table} ${style.sub_head_content_table_report} ${style.testList_tableWrap}`}
              >
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: '10%', paddingLeft: '2%' }} className={` ${style.first}  ${style.pointer} `}>
                        <span>Task ID</span>
                      </th>
                      <th className={` ${style.first} ${style.pointer}`} style={{ width: '15%', paddingLeft: '1%' }}>
                        <span>Assigned To</span>
                        <svg
                          onClick={() => sortAssignFunction()}
                          width="19"
                          height="12"
                          viewBox="0 0 19 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            transform: getRotation('-assign_to'),
                            transition: 'transform 0.3s ease',
                          }}
                        >
                          <path
                            d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                            fill={sortAssignToIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                            fill={sortAssignToIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                            fill={sortAssignToIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                            fill={sortAssignToIcon ? '#00ABFB' : '#999090'}
                          />
                        </svg>
                      </th>
                      <th className={` ${style.first} ${style.pointer} `} style={{ width: '17%', paddingLeft: '1%' }}>
                        <span>Question Bank</span>
                        <svg
                          onClick={() => sortQuestionBankFunction()}
                          width="19"
                          height="12"
                          viewBox="0 0 19 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            transform: getRotation('-question_bank'),
                            transition: 'transform 0.3s ease',
                          }}
                        >
                          <path
                            d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                            fill={sortQuestionBankIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                            fill={sortQuestionBankIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                            fill={sortQuestionBankIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                            fill={sortQuestionBankIcon ? '#00ABFB' : '#999090'}
                          />
                        </svg>
                      </th>
                      <th className={` ${style.first}   ${style.pointer}`} style={{ width: '13%', paddingLeft: '1%' }}>
                        <span>Task Type</span>
                        <svg
                          onClick={() => sortTaskTypeFunction()}
                          width="19"
                          height="12"
                          viewBox="0 0 19 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            transform: getRotation('-task_type'),
                            transition: 'transform 0.3s ease',
                          }}
                        >
                          <path
                            d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                            fill={sortTaskTypeIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                            fill={sortTaskTypeIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                            fill={sortTaskTypeIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                            fill={sortTaskTypeIcon ? '#00ABFB' : '#999090'}
                          />
                        </svg>
                      </th>

                      <th className={` ${style.first}  ${style.pointer}`} style={{ width: '15%', paddingLeft: '1%' }}>
                        <span>Created On</span>
                        <svg
                          onClick={() => sortCreatedFunction()}
                          width="19"
                          height="12"
                          viewBox="0 0 19 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            transform: getRotation('-created_at'),
                            transition: 'transform 0.3s ease',
                          }}
                        >
                          <path
                            d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                            fill={sortCreatedAtIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                            fill={sortCreatedAtIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                            fill={sortCreatedAtIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                            fill={sortCreatedAtIcon ? '#00ABFB' : '#999090'}
                          />
                        </svg>
                      </th>
                      <th className={` ${style.first}  ${style.pointer}`} style={{ width: '13%', paddingLeft: '1%' }}>
                        <span>End Date</span>
                        <svg
                          onClick={() => sortEndDateFunction()}
                          width="19"
                          height="12"
                          viewBox="0 0 19 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            transform: getRotation('-end_date'),
                            transition: 'transform 0.3s ease',
                          }}
                        >
                          <path
                            d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                            fill={sortEndDateIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                            fill={sortEndDateIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                            fill={sortEndDateIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                            fill={sortEndDateIcon ? '#00ABFB' : '#999090'}
                          />
                        </svg>
                      </th>
                      <th className={` ${style.first}  ${style.pointer}`} style={{ width: '10%', paddingLeft: '1%' }}>
                        <span>Items</span>
                        <svg
                          onClick={() => sortItemsFunction()}
                          width="19"
                          height="12"
                          viewBox="0 0 19 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            transform: getRotation('-item_count'),
                            transition: 'transform 0.3s ease',
                          }}
                        >
                          <path
                            d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                            fill={sortItemIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                            fill={sortItemIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                            fill={sortItemIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                            fill={sortItemIcon ? '#00ABFB' : '#999090'}
                          />
                        </svg>
                      </th>

                      <th className={` ${style.first} ${style.pointer}`} style={{ width: '7%', paddingLeft: '1%' }}>
                        <span>Status</span>
                        <svg
                          onClick={() => sortStatusFunction()}
                          width="19"
                          height="12"
                          viewBox="0 0 19 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            transform: getRotation('-task_status'),
                            transition: 'transform 0.3s ease',
                          }}
                        >
                          <path
                            d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                            fill={sortStatusIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                            fill={sortStatusIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                            fill={sortStatusIcon ? '#00ABFB' : '#999090'}
                          />
                          <path
                            d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                            fill={sortStatusIcon ? '#00ABFB' : '#999090'}
                          />
                        </svg>
                      </th>

                      <th className={`${style.pointer}`} style={{ width: '5%', paddingLeft: '1%' }}></th>
                    </tr>
                  </thead>

                  {isLoading ? (
                    <tbody>
                      <tr>
                        <td colSpan="7" className={style.loader_message}>
                          Loading...
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      {taskList?.results?.map((item, i) => (
                        <tr key={i} className={style.table_body_content}>
                          <td>
                            <div className={`${style.user_management_table_body_content} ${style.rowHeadLayout}`}>
                              <div
                                className={style.created_class}
                                onClick={() => {
                                  navigate(`/task-management/details/${item.task_id}`);
                                }}
                                style={{ cursor: 'pointer', paddingLeft: '16%', width: '85%' }}
                              >
                                {item?.task_id ?? '-'}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div
                              className={`${style.user_management_table_body_content} ${style.userLasttname}`}
                              style={{ width: '100%' }}
                            >
                              {item?.assigned_to ?? '-'}
                            </div>
                          </td>
                          <td>
                            <div
                              className={`${style.user_management_table_body_content} ${style.user_management_table_body_content_new}`}
                            >
                              {item?.question_bank ?? '-'}
                            </div>
                          </td>
                          <td>
                            <div
                              className={`${style.user_management_table_body_content} ${style.user_management_table_body_content_new}`}
                            >
                              {item?.task_type ?? '-'}
                            </div>
                          </td>

                          <td>
                            <div
                              className={`${style.user_management_table_body_content} ${style.user_management_table_body_content_new}`}
                            >
                              {item?.created_on ?? '-'}
                            </div>
                          </td>

                          <td>
                            <div
                              className={`${style.user_management_table_body_content} ${style.userOrganization}`}
                              style={{ width: '100%' }}
                            >
                              <span> {item?.end_date ?? '-'}</span>
                            </div>
                          </td>
                          <td>
                            <div
                              className={`${style.user_management_table_body_content} ${style.userOrganization}`}
                              style={{ width: '100%' }}
                            >
                              <span> {item?.item_count ?? '-'}</span>
                            </div>
                          </td>
                          <td>
                            <div
                              className={`
                              ${style.taskStatusBtn} 
                              ${item?.status === 'In-Process' ? style.progressTaskStatus : ''} 
                               ${item?.status === 'To-Do' ? style.toDOTaskStatus : ''} 
                                  
                              ${item?.status === 'In-Review' ? style.reviewTaskStatus : ''} 
                              ${item?.status === 'Approved' ? style.approvedTaskStatus : ''}
                           `}
                            >
                              <span style={{ width: '85%' }}>{item?.status || '-'}</span>
                            </div>
                          </td>

                          {item?.status !== 'Approved' && item?.status !== 'In-Review' && (
                            <td>
                              <div
                                className={style.taskEditIcon}
                                onClick={() => navigate(`/task-management/edit/${item.task_id}`)}
                              >
                                <span>
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M3 22H21"
                                      stroke="#00ABFB"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M13.2603 3.59924L5.05034 12.2892C4.74034 12.6192 4.44034 13.2692 4.38034 13.7192L4.01034 16.9592C3.88034 18.1292 4.72034 18.9292 5.88034 18.7292L9.10034 18.1792C9.55034 18.0992 10.1803 17.7692 10.4903 17.4292L18.7003 8.73924C20.1203 7.23924 20.7603 5.52924 18.5503 3.43924C16.3503 1.36924 14.6803 2.09924 13.2603 3.59924Z"
                                      stroke="#00ABFB"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M11.8896 5.04883C12.3196 7.80883 14.5596 9.91883 17.3396 10.1988"
                                      stroke="#00ABFB"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  )}
                </table>
              </div>
            ) : (
              <>
                {taskList?.error ? (
                  <div className={style.noData}>
                    <div className={style.noDataText}>No task found.</div>
                  </div>
                ) : (
                  <div colSpan="7" className={style.loader_message}>
                    Loading...
                  </div>
                )}
              </>
            )}
            {/*______________________________ PAGINATION ______________________________  */}
            <div className={`${style.Task_paginationWrap}`}>
              {totalCount !== 0 && (
                <Pagination
                  totalCount={totalCount}
                  limit={limit}
                  currentPage={currentPage}
                  inputPage={inputPage}
                  offset={offset}
                  last={last}
                  nextUrl={taskList.next}
                  prevUrl={taskList.previous}
                  setOffset={setOffset}
                  setCurrentPage={setCurrentPage}
                  setInputPage={setInputPage}
                  setLast={setLast}
                />
              )}
            </div>
            {/*______________________________ PAGINATION ______________________________  */}
          </div>
        </div>
        <RecentActivity />
      </div>
    </AuthLayout>
  );
};
export default Tasklist;
